import { sanitizeValue } from '@cbgms/components/list/query'
import { KnockOperator, KnockOrderByOptions } from './KnockTypes'

export { isEnum, isSliceOfEnum } from '@cbgms/base/utils/enum/is-enum'

export interface IKnockFilter {
  key: string
  filter?: string
  filterOperator?: KnockOperator
  sortOrder?: KnockOrderByOptions
  sortIndex?: number
}

export const fieldsToString = (fields: string[]) => fields.join(',')

/*
 * Takes a filter object and turns it into a knock compatible search string
 * Defaults to EqualTo Operator, and wraps your query in % characters when it's a wildcard search
 */
export const filtersToString = (filters: IKnockFilter[], predefinedSearch?: string) => {
  const regularFilters = filters
    .filter(filter => filter.filter && filter.filter !== '')
    .map(filter => {
      const isWildcard = filter.filterOperator === KnockOperator.StringWildcard

      const operator = filter.filterOperator || KnockOperator.EqualTo
      const filterString = `${isWildcard ? '%' : ''}${sanitizeValue(filter.filter || '')}${isWildcard ? '%' : ''}`

      return `${filter.key}|${operator}|${filterString}`
    })

  const searchQuery = [...regularFilters, predefinedSearch].filter(f => !!f).join(',')
  return searchQuery
}

export const sortOrdersToString = (filters: IKnockFilter[]) =>
  filters
    .filter(filter => filter.sortOrder)
    .sort((a, b) => ((a.sortIndex || Number.MAX_SAFE_INTEGER) > (b.sortIndex || Number.MAX_SAFE_INTEGER) ? 1 : -1))
    .map(filter => filter.sortOrder !== '' && `${filter.key}|${filter.sortOrder}`)
    .filter(filter => filter)
    .join(',')
